import PropTypes from "prop-types";
import InnerHTML from "dangerously-set-html-content";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

export const Title = ({ text, truncate }) => (
  <Typography.LabelSm weight="medium" color="text-default">
    <InnerHTML
      className={classNames({
        truncate: truncate,
      })}
      html={text}
    />
  </Typography.LabelSm>
);

Title.propTypes = {
  text: PropTypes.string.isRequired,
  truncate: PropTypes.bool,
};
